/**
 * Account Sub Menu Active Tab
 * 
 */

custom.accountActiveTab = (() => {
    
    const relativePath = window.location.search !== '' ?
        window.location.pathname + window.location.search :
        window.location.pathname;
    const menuTab = 'submenu-tab__menu a';
    const activeClass = 'active';
    
    function addActiveClassToTab(index=null, name=null) {
        const href = $(name).attr('href');
        
        if ($(name).hasClass(activeClass)) return;
        
        if ((href === relativePath) && !$(name).hasClass(activeClass)) {
            $(name).addClass(activeClass)
        }
    }

	function init() {
		if(!$(`.${menuTab}`).length) return;
		$(`.${menuTab}`).each((index, name) => addActiveClassToTab(index, name));
	}

	return {
		init
	}

})();


// WEBPACK FOOTER //
// ./src/scripts/src/custom/account-active-tab.js